import React, { useState, useEffect } from "react";
import { Layout, Row, Col, Drawer, Button, Divider } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import Navigation from "./Navigation";
import UserMenu from "./UserMenu";
import Logo from "./Logo";
import LanguageSelector from "./LanguageSelector";

const { Header: AntHeader } = Layout;

const Header = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [drawerVisible, setDrawerVisible] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isNavMenu = windowWidth < 880;
  const isUserCompact = windowWidth < 650;

  return (
    <AntHeader
      style={{
        background: "linear-gradient(to right,rgb(235, 245, 255, 0.0),rgb(215, 234, 255, 0.0),rgb(228, 241, 255, 0.0))", // Light blue gradient from left to right
        padding: "0 24px",
        position: "absolute",
        top: 0,
        zIndex: 1000,
        width: "100%",
        display: "flex",
        alignItems: "center",
        //backdropFilter: "blur(8px)",
        //WebkitBackdropFilter: "blur(8px)", // Safari support
        //borderBottom: "1px solid rgba(0, 0, 0, 0.06)", // Soft bottom border
        //boxShadow: '0 2px 50px rgba(0, 0, 0, 0.2)',
      }}
    >
      <Row justify="space-between" align="middle" style={{ width: "100%" }}>
        <Col style={{ display: "flex", alignItems: "center" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
            {(isNavMenu || isMobile) && (
              <Button
                type="text"
                icon={<MenuOutlined />}
                onClick={() => setDrawerVisible(true)}
              />
            )}
            {!isMobile && (
              <div style={{ filter: 'drop-shadow(2px 2px 4px rgba(255, 255, 255, 0.4))' }}>
                <Logo.Text hyperlink={true} size={20} />
              </div>
            )}
          </div>
        </Col>
        
        {/* Language selector and user menu - different styling for mobile */}
        <Col style={{ 
          display: "flex", 
          alignItems: "center", 
          gap: "6px",
          justifyContent: isMobile ? "flex-start" : "flex-end" 
        }}>
          <LanguageSelector />
          <Divider type="vertical" style={{ height: '20px', margin: '0 2px' }} />
          <UserMenu isCompact={isUserCompact} />
        </Col>
      </Row>
      
      {/* Absolutely centered navigation */}
      <div style={{
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 999,
        display: isNavMenu ? "none" : "block"
      }}>
        <Navigation />
      </div>
      
      {(isNavMenu || isMobile) && (
        <Drawer
          title={<Logo.Text hyperlink={true} size={20} />}
          placement="left"
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
          width={300}
          styles={{
            header: {
              padding: "16px 24px",
              borderBottom: "1px solid rgba(0, 0, 0, 0.06)",
            },
          }}
        >
          <Navigation mode="vertical" />
        </Drawer>
      )}
    </AntHeader>
  );
};

export default Header;
